<template>
  <div class="alerts">
    <div v-for="icon in icons" :key="icon.key">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex align-center" v-bind="attrs" v-on="on">
            <AlarmIcon
              class="mr-2"
              :class="{ load: loading }"
              :state="icon.state"
            />
            <span v-if="!loading" class="a-title">{{ alarms[icon.key] }}</span>
            <v-skeleton-loader v-else type="text" width="15px" height="10px" />
          </div>
        </template>
        <span>{{ icon.description }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import AlarmIcon from "@/components/Icons/AlarmIcon.vue";
export default {
  name: "AlarmsIcons",
  components: {
    AlarmIcon,
  },
  props: {
    alarms: { type: Object, default: () => ({ high: 0, medium: 0, low: 0 }) },
    loading: { type: Boolean, default: true },
  },
  data() {
    return {
      icons: [
        {
          state: 0,
          key: "high",
          description: "High priority",
        },
        {
          state: 1,
          key: "medium",
          description: "Medium priority",
        },
        {
          state: 2,
          key: "low",
          description: "Low priority",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.alerts {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
}
.load {
  color: $gray-light !important;
}
</style>